import { render, staticRenderFns } from "./model-addedit-voucher.vue?vue&type=template&id=4ed4f939&"
import script from "./model-addedit-voucher.vue?vue&type=script&lang=js&"
export * from "./model-addedit-voucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports